import React, { useRef } from 'react';
import { useTheme } from '@mui/material/styles';
import ReactECharts from 'echarts-for-react';
import 'echarts-wordcloud';
import { lighten, darken } from '@mui/system';

const buildData = (data, colour) => data.map((e, i) => ({
    ...e,
    textStyle: {
        fontFamily: 'Roboto, sans-serif',
        fontWeight: 'bold',
        color: i > 0 ? i < 5 ? darken(colour, i / 10) :lighten(colour, i / 10) : colour
    }
}));

const EngagementBySubjectChart = ({ data, colour, chartHeight = 250 }) => {
    const ref = useRef(null);
    const theme = useTheme();

    const options = {
        tooltip: {
            trigger: 'item',
            formatter: params => `${params.marker}${params.name}: <b>${params.value}</b>`
        },
        series: [{
            type: 'wordCloud',
            shape: 'diamond',
            keepAspect: false,
            left: 'center',
            top: 'center',
            width: '100%',
            height: '100%',
            right: null,
            bottom: null,
            sizeRange: [12, 60],
            rotationRange: [-0, 0],
            rotationStep: 45,
            gridSize: 8,
            drawOutOfBound: false,
            shrinkToFit: true,
            layoutAnimation: true,
            emphasis: {
                focus: 'self',
                textStyle: {
                    color: theme.palette.text.main
                }
            },
            data: data ? buildData(data, colour) : []
        }]
    };

    return (
        <ReactECharts
            option={options}
            style={{ height: chartHeight }}
            opts={{ renderer: 'svg' }}
            ref={ref}
        />
    );
};

export default EngagementBySubjectChart;
